import { memo, ReactNode } from "react"

import styled, { css } from "styled-components"

import { colors, spacing, typography, IconErrorFilledSmall } from "@izettle/otto"

import { SemanticState } from "../../enumerations"
import { Icon } from "../icon"

export type InputMessageProps = {
  children?: ReactNode | ReactNode[]
  semanticState?: SemanticState
  id?: string
}

const StyledIcon = styled(Icon)`
  margin-right: ${spacing.xxSmall};
`

const mixinTypography = css`
  ${({ semanticState }: InputMessageProps) =>
    ({
      [SemanticState.Warning]: typography.small,
      [SemanticState.Error]: typography.small,
      [SemanticState.Success]: typography.small,
      [SemanticState.Default]: typography.smallSecondary,
    })[semanticState ?? SemanticState.Default]}
`

const mixinColor = css`
  color: ${({ semanticState }: InputMessageProps) =>
    ({
      [SemanticState.Warning]: colors.text.warning,
      [SemanticState.Error]: colors.text.error,
      [SemanticState.Success]: colors.text.success,
      [SemanticState.Default]: colors.text.default,
    })[semanticState ?? SemanticState.Default]};
`

const InputMessageMemoized = memo(styled.p<InputMessageProps>`
  margin-top: ${spacing.xxSmall};
  padding-left: ${spacing.small};
  ${mixinTypography}
  ${mixinColor}
`)

export const InputMessage = ({ children, ...props }: InputMessageProps) => (
  <InputMessageMemoized {...props}>
    {props.semanticState === SemanticState.Error && (
      <StyledIcon svgIcon={IconErrorFilledSmall} />
    )}
    {children}
  </InputMessageMemoized>
)
